import React from 'react';

function Impressum() {
  return (
    <div className="min-h-screen bg-white pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#1B4965] mb-8">Impressum</h1>
        
        <div className="prose prose-lg">
          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            Angaben gemäß § 5 TMG
          </h2>
          <p className="mb-4">
            Armin Breig<br />
            KFZ - Sachverständigenbüro (Einzelunternehmer)<br />
            Rosenstraße<br />
            Gebäude 5<br />
            76356 Weingarten
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            Kontakt
          </h2>
          <p className="mb-4">
            Telefon: +49 172 9507571<br />
            E-Mail: armin.breig@web.de
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            Umsatzsteuer-ID
          </h2>
          <p className="mb-4">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            USt-IdNr. DE451395534
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            Angaben zur Berufshaftpflichtversicherung
          </h2>
          <p className="mb-4">
            Name und Sitz des Versicherers:<br />
            Württembergische Versicherung AG<br />
            W&W-Platz 1<br />
            70806 Kornwestheim<br />
            Deutschland<br /><br />
            Telefon: +49 0 711 6620
          </p>
        </div>
      </div>
    </div>
  );
}

export default Impressum;